/* @generated from adl module ferovinum.datacontracts.expensesettlement */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';

export interface ExpenseSettlementRawRecord {
  id: common_strings.StringNE;
  expenseId: common_strings.StringNE;
  settlementMethod: common_strings.StringNE;
  capexDescriptionId: (common_strings.StringNE|null);
  invoiceLineItemId: (common_strings.StringNE|null);
  purchaseRequestId: (common_strings.StringNE|null);
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeExpenseSettlementRawRecord(
  input: {
    id: common_strings.StringNE,
    expenseId: common_strings.StringNE,
    settlementMethod: common_strings.StringNE,
    capexDescriptionId: (common_strings.StringNE|null),
    invoiceLineItemId: (common_strings.StringNE|null),
    purchaseRequestId: (common_strings.StringNE|null),
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): ExpenseSettlementRawRecord {
  return {
    id: input.id,
    expenseId: input.expenseId,
    settlementMethod: input.settlementMethod,
    capexDescriptionId: input.capexDescriptionId,
    invoiceLineItemId: input.invoiceLineItemId,
    purchaseRequestId: input.purchaseRequestId,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const ExpenseSettlementRawRecord_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.datacontracts.expensesettlement","decl":{"annotations":[{"value":{"datasetName":"raw_expense_settlements"},"key":{"moduleName":"ferovinum.datacontracts.common","name":"RawExportDataset"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseId","default":{"kind":"nothing"},"name":"expenseId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"settlementMethod","default":{"kind":"nothing"},"name":"settlementMethod","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"capexDescriptionId","default":{"kind":"nothing"},"name":"capexDescriptionId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"invoiceLineItemId","default":{"kind":"nothing"},"name":"invoiceLineItemId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"purchaseRequestId","default":{"kind":"nothing"},"name":"purchaseRequestId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"ExpenseSettlementRawRecord","version":{"kind":"nothing"}}};

export const snExpenseSettlementRawRecord: ADL.ScopedName = {moduleName:"ferovinum.datacontracts.expensesettlement", name:"ExpenseSettlementRawRecord"};

export function texprExpenseSettlementRawRecord(): ADL.ATypeExpr<ExpenseSettlementRawRecord> {
  return {value : {typeRef : {kind: "reference", value : snExpenseSettlementRawRecord}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.datacontracts.expensesettlement.ExpenseSettlementRawRecord" : ExpenseSettlementRawRecord_AST
};
